import React, { useState, useEffect } from "react";
import { fetchProgramStats } from "../../../../../utils/axios";
import "./ProgramSummaryTable.css";

const ProgramSummaryTable = () => {
  const [chartType, setChartType] = useState("bar");
  const [programData, setProgramData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadData = async () => {
    try {
      setLoading(true);
      const data = await fetchProgramStats();
      setProgramData(data);
      setError(null);
    } catch (err) {
      setError("Failed to load program statistics. Please try again later.");
      console.error("Error loading program stats:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center bg-white rounded shadow p-4"
        style={{ height: "16rem" }}
      >
        <div
          className="spinner-border text-primary"
          style={{ width: "3rem", height: "3rem" }}
          role="status"
        ></div>
      </div>
    );
  }

  return (
    <div>
      {programData && programData.customer_stats && (
        <div className="mt-4">
          <div className="table-responsive">
            <table className="table table-bordered table-hover bg-white">
              <thead className="table-primary text-center">
                <tr>
                  <th className="text-uppercase text-white small">Program</th>
                  <th className="text-uppercase text-white small">
                    Submissions
                  </th>
                  <th className="text-uppercase text-white small">Valid</th>
                  <th className="text-uppercase text-white small">
                    Rewards Paid
                  </th>
                  <th className="text-uppercase text-white small">Remaining</th>
                  <th className="text-uppercase text-white small">
                    Highest Payout
                  </th>
                </tr>
              </thead>
              <tbody>
                {programData.customer_stats.map((program) => (
                  <tr key={program.program_id} className="align-middle">
                    <td className="fw-semibold text-dark text-bold">
                      {program.program_title}
                    </td>
                    <td>
                      <span className="badge bg-info-subtle text-info p-3 py-2">
                        {program.total_submissions}
                      </span>
                    </td>
                    <td>
                      <span className="badge bg-success-subtle text-muted px-3 py-2">
                        {program.total_valid_submissions}
                      </span>
                    </td>
                    <td>
                      <span className="badge bg-warning-subtle text-success px-3 py-2">
                        ${program.rewards_paid.toFixed(2)}
                      </span>
                    </td>
                    <td>
                      <span className="badge bg-danger-subtle text-danger px-3 py-2">
                        ${program.remaining_rewards.toFixed(2)}
                      </span>
                    </td>
                    <td>
                      <span className="badge bg-secondary-subtle text-dark px-3 py-2">
                        ${program.highest_rewards.toFixed(2)}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProgramSummaryTable;
